import { RouteListTabs } from "../enums/RouteListTabs";
import { FilterTypes } from "../models/route";
import STOP_FILTERS from "../enums/RouteDetailFilters";

export const LOGIN_PAGE = {
  LOAD: "Cj3c6E6GAqAACSvw",
  INTERFACE_ID: "9oZ06E6GAqAACSP4",
  SELECT_SIGN_IN_WITH_GOOGLE: "5r3c6E6GAqAACSwG",
};

export const ROUTE_PAGE = {
  LOAD: "astOsE6GAqAACak3",
  INTERFACE_ID: "P9CUsE6GAqAACeSu",
};

export const STOP_LIST = {
  LOAD: "jaSL7U6GAqAAKy1t",
  ON_CHANGE_POSTCODE: "nrFYr06GAqAAKzpv",
  ON_CHANGE_STOP_TIME: "oe9sr06GAqAAK0K6",
  ON_CLICK_REQUEST: "ef64us6GAqAAK26R",
  ON_SELECT_ROW: "2rG2006GAqAAK9mU",
  ON_SHIFT_CLICK: "m1q0M06GAqAAK1Dy",
  ON_SORT_COLUMN: "cc7G006GAqAAK9Wh",
};

export const HEADER = {
  LOAD: "bhTdsE6GAqAACbLl",
  SELECT_DATE: "otZWOE6GAqAACZnz",
  SELECT_DEPOT: "uacncE6GAqAACZps",
  SELECT_MENU: "tzjXcE6GAqAACZ5C",
  TYPE_DEPOT: "WQ5HcE6GAqAACZmK",
};

export const APP_MENU = {
  LOAD: "3Yd3cE6GAqAACZ9D",
  SELECT_CENTRAL_SERVICES: "f8i8SE6GAqAACUp1",
  SELECT_DEPOT_OPERATIONS: "f4I8SE6GAqAACUow",
  SELECT_DEPOT_PLANNING: "5qu8SE6GAqAACUqm",
  SELECT_SIGN_OUT: "qcePcE6GAqAACZ_Z",
};

export const DATE_PICKER = {
  LOAD: "LimWOE6GAqAACZmS",
  SELECT_CANCEL: "JRv2OE6GAqAACZum",
  SELECT_DATE: ".E12OE6GAqAACZtJ",
  SELECT_OK: "OW0OOE6GAqAACZvn",
};

export const SELECT_STOP_BY_CRITERIA = {
  LOAD: "8k5Mh06GAqAAK7qL",
  SELECT_ADD: "WQcap06GAqAAKzJU",
  SELECT_APPLY_CRITERIA: "sLASZ06GAqAAKzke",
  SELECT_CLEAR_ALL_CRITERIA: "Ts3CZ06GAqAAKzbI",
  SELECT_CRITERIA: "fbtch06GAqAAK7vX",
  SELECT_REMOVE: "nqmap06GAqAAKzLO",
};

export const NAV_PANEL = {
  LOAD: "XyhLSE6GAqAACXK7",
  SELECT_ROUTES: "YhmfZE6GAqAACcZu",
  SELECT_SECTIONS: "N9upyE6GAqAACRKv",
};

export const SECTIONS = {
  LOAD: "Aoc8OE6GAqAACX0h",
  CLICK_SECTION: "9cg55E6GAqAACQV_",
  DOUBLE_CLICK_SECTION: "X6XfZE6GAqAACcfs",
  SELECT_LIST_VIEW: "qv7SOE6GAqAACYPK",
  SELECT_STATS_VIEW: "ky0yOE6GAqAACYRT",
};

export const ROUTES = {
  LOAD: "blHBgk6GAqAAKyNg",
  CLICK_LOCK_ICON: "XYgMys6GAqAAKxZe",
  CLICK_LOCK_ROUTE: "H2L1i66GAqAAK3_7",
  CLICK_NEW_ROUTE_ICON: "AgwMoc6GAqAAK4_d",
  CLICK_ROUTE: "oNf.gk6GAqAAKyGa",
  CLICK_ROUTE_OPTIONS_MENU: "OMali66GAqAAK3yE",
  CLICK_ROUTE_STATUS_ICON: "8vvMys6GAqAAKxcp",
  CLICK_UNLOCK_ROUTE: "asP1i66GAqAAK4A2",
  DOUBLE_CLICK_ROUTE: "VFf.gk6GAqAAKyF.",
  SELECT_ROUTE_NUMBER: "y53EWk6GAqAACQSH",
  SELECT_ROUTES_STATUS: "kzUsys6GAqAAKxeY",
};

export const STOP_PARCELS_LIST = {
  CLICK_PARCEL_NUMBER: "1w5wR06GAqAAK7ga",
  CLICK_REQUEST: "dyTAhs6GAqAAZEu5",
  CLICK_SPLIT: "VYvo5s6GAqAAZGOm",
  SELECT_BULK: "AtPvr06GAqAAK43C",
  SELECT_KING_PARCEL: "J2err06GAqAAK4dR",
  SELECT_PARCEL_ROW: "AgSLr06GAqAAK4RA",
};

export const ROUTE_MANAGEMENT = {
  LOAD: "HuE8M06GAqAAKyAp",
  CLICK_ADD_NEW_CRITERIA: "W.jV106GAqAAK9oT",
  CLICK_BACK: "DGIQs06GAqAAK7_X",
  CLICK_CLEAR_SELECTED: "jHjz106GAqAAK91e",
  CLICK_MERGE: "b2Wo5s6GAqAAZF_g",
  CLICK_MOVE_TO: "A2_Mb06GAqAAK9RS",
  CLICK_OPTIMISE: "GMU40M6GAqAAK2Yr",
  CLICK_REMOVE_CRITERIA: "7N0ZEs6GAqAAK09S",
  CLICK_SAVE: "FZbElc6GAqAAZEx4",
  CLICK_SCHEDULE: "AsgQ0M6GAqAAK47v",
  CLICK_SELECT_MULTIPLE: "JShhO06GAqAAKyqK",
  SELECT_MOVE_DOWN: "TtaUb06GAqAAK88o",
  SELECT_MOVE_UP: "QHN0b06GAqAAK9IT",
};

export const ROUTES_TABS = {
  [RouteListTabs.compact]: "Pxzcak6GAqAAKw_8",
  [RouteListTabs.detailed]: "UGPcak6GAqAAKxBZ",
  [RouteListTabs.stats]: "YHw8ak6GAqAAKxB4",
  [RouteListTabs.defRoutes]: "pXVjXk6GAqAAK2e6",
};

export const DRIVER_REQUESTS_MODAL = {
  LOAD: "YeZghs6GAqAAZFPR",
  CLICK_ACCEPT: "KbfMhs6GAqAAZDWZ",
  CLICK_CLOSE: "F1pMhs6GAqAAZDSk",
  CLICK_DEFER: "oYDMhs6GAqAAZDVA",
  CLICK_REJECT: "FrrMhs6GAqAAZDVr",
};

export const TRANSFER_MODAL = {
  LOAD: "vKu2Kc6GAqAAKwiZ",
  SELECT_ROUTE: "lxrlZs6GAqAAZFQl",
};

export const TRANSFER_REQUESTS_MODAL = {
  LOAD: "F4JKZs6GAqAAZDEk",
  CLICK_CLOSE: "WZnjjs6GAqAAKwi2",
  CLICK_CONFIRM: "nyXVZs6GAqAAZFlE",
};

export const TRANSFER_STOP_MODAL = {
  CLICK_OPTIMISE: "cUYrqc6GAqAAKz9F",
  CLICK_SCHEDULE: "FsYrqc6GAqAAKz9l",
};

export const FILTERS = {
  LOAD: "1oVYyU6GAqAAKzGB",
  SELECT_HIDE_FILTERS: "BEgaKU6GAqAAK1WM",
  SELECT_SHOW_FILTERS: "0V1iKU6GAqAAK1Sf",
};

export const STATUS_FILTER = {
  [FilterTypes.routeStatus]: {
    all: "BamYuU6GAqAAK2Rl",
    single: "96nBmU6GAqAAKyoY",
  },
  [FilterTypes.exceptionsAndOpportunity]: {
    all: "6W4EuU6GAqAAK36h",
    single: "x04EuU6GAqAAK35S",
  },
  [FilterTypes.stopType]: {
    all: "wjlLuU6GAqAAK17p",
    single: "KplLuU6GAqAAK15p",
  },
  [FilterTypes.driverRequests]: {
    all: "w_N8Nu6GAqAASUY9",
    single: "MNN8Nu6GAqAASUW2",
  },
  [FilterTypes.loadTime]: {
    all: "s5NWtu6GAqAASSzz",
    single: "RyNWtu6GAqAASSyK",
  },
};

export const SPLIT_STOP_MODAL = {
  LOAD: "ebaJas6GAqAAK104",
  CLICK_APPLY_SPLIT: "bhwo6s6GAqAAK5nJ",
  CLICK_CLOSE: "rJE5as6GAqAAK2Kz",
  SELECT_EXISTING_STOP: "K3xras6GAqAAK5Fi",
  SELECT_MATCHING_POSTCODES: "BIZQ6s6GAqAAK5WR",
  SELECT_NEW_STOP: "ic3Q6s6GAqAAK5cF",
  SELECT_SPLIT_INTO_STOP: "uJjw6s6GAqAAK5gb",
};

export const CREATE_NEW_ROUTE = {
  LOAD: "VViMAc6GAqAAK0mW",
  CANCEL_UNSAVED_CHANGES: "CwKCoc6GAqAAK5Yd",
  CLICK_CANCEL_DOUBLE_ROUTE: "MJxMoc6GAqAAK5Dz",
  CLICK_CLOSE: "Fcksoc6GAqAAK5IM",
  CLICK_CREATE_ROUTE: "dQ4Koc6GAqAAK5b1",
  CLICK_PROCEED_DOUBLE_ROUTE: "O41soc6GAqAAK5KX",
  CONFIRM_UNSAVED_CHANGES: "ZAKCoc6GAqAAK5YM",
  ON_CLICK_NEXT: "hjvMAc6GAqAAK0wi",
  ON_SELECT_DRIVER: "h4u8oc6GAqAAK5VX",
};

export const DRIVER_DETAILS = {
  LOAD: "naFcWk6GAqAACRbc",
  CANCEL_CHANGE_PASSWORD: "0uFqLk6GAqAAKzGV",
  CANCEL_UNSAVED_CHANGES: "7qyMi06GAqAAK0DG",
  CONFIRM_CHANGE_PASSWORD: "rHcqLk6GAqAAKyy3",
  CONFIRM_UNSAVED_CHANGES: "rhkMi06GAqAAK0B5",
  SELECT_ADD_NEW_DRIVER: "MKlHdk6GAqAAKyU8",
  SELECT_CHANGE_PASSWORD: "2TxPBk6GAqAACaJ1",
  SELECT_CLOSE: "6J5hfk6GAqAAK7dp",
  SELECT_DRIVER: "N0sBWk6GAqAACYf4",
  SELECT_SAVE_CHANGES: "jqbHWk6GAqAACRHX",
};

export const SCHEDULE_MODAL = {
  LOAD: "1_6Y0M6GAqAAK2TM",
  CANCEL_RESET_ALL_CHANGES: "Dtg8Hy6GAqAAK0PD",
  CLICK_CLOSE: "9pRm0M6GAqAAK3Vt",
  CLICK_MAKE_MORE_CHANGES: "89aW0M6GAqAAK3oJ",
  CLICK_RESET_ALL_CHANGES: "6ONW0M6GAqAAK3qe",
  CLICK_SAVE: "o9Oe0M6GAqAAK30b",
  CONFIRM_RESET_ALL_CHANGES: "NuQcHy6GAqAAK0Bm",
  CONFIRM_RESET_CHANGES: "yDnU8M6GAqAAK8DB", // TODO
  REJECT_RESET_CHANGES: "q5c08M6GAqAAK8FQ", // TODO
};

export const IN_BUILD_WARNING = {
  LOAD: "hvHRF86GAqAAK7Nd",
  CLICK_CANCEL: "hn_RF86GAqAAK7Pm",
  CLICK_CONTINUE: "6vExF86GAqAAK7Qa",
};

export const MERGE_STOPS = {
  LOAD: "x4rJFM6GAqAAK0q7",
  CLICK_APPLY_MERGE: "qZLKss6GAqAAKxNd",
  CLICK_CLOSE: "bSMiss6GAqAAKxK1",
  SELECT_MATCHING_POSTCODES: "wM8XlM6GAqAAK8JY",
  SELECT_MERGE_TO_STOP: ".crxMs6GAqAAKwvp",
};

export const STOP_MOVE_TO_MODAL = {
  LOAD: "B0N_f06GAqAAK21U",
  CONFIRM: "yroM_06GAqAAK3Az",
  SELECT_CLOSE: "7j7FAM6GAqAAK4Hx",
  SELECT_STOP: "k4zg_06GAqAAK28W",
};

export const SELECT_MULTIPLE_MODAL = {
  LOAD: ".13bO06GAqAAKzXJ",
  SELECT_CLOSE: "YyyHO06GAqAAKzkv",
  SELECT_CONFIRM: "u2lHO06GAqAAKzmh",
};

export const STOP_QUICK_FILTERS = {
  [STOP_FILTERS.CONSOLIDATED]: "5ePP006GAqAAKwYE",
  [STOP_FILTERS.EXCEPTIONS]: "xRUT006GAqAAKwKi",
  [STOP_FILTERS.MATCHING_POSTCODES]: "Yoav006GAqAAKwml",
  [STOP_FILTERS.NON_CADS]: "MbX_006GAqAAKwxr",
  [STOP_FILTERS.NON_COMPATIBLES]: "TlXf006GAqAAKwr2",
  [STOP_FILTERS.NON_LOADED_PARCELS]: "J0u_006GAqAAKwvC",
  [STOP_FILTERS.OPPORTUNITY]: "8O6P006GAqAAKwU6",
  [STOP_FILTERS.PREMIUMS]: "BxPX006GAqAAKwSC",
  [STOP_FILTERS.SHOW_IN_ROUTE]: "dYc4M06GAqAAK0ox",
};

export const MAP_BOX = {
  LOAD: "Ho8Mfy6GAqAAK.KK",
};

export const PICKUP_STOP_MODAL = {
  LOAD: "zXJahs6GAqAAZEKr",
  CLICK_OK: "kjLahs6GAqAAZENG",
};

export const ROUTE_DETAIL = {
  LOAD: "Ebjz7U6GAqAAKyx8",
};

export const PARCEL_SEARCH_MODAL = {
  LOAD: "oYSTS26D.AAAAbet",
  CLICK_CLOSE: "Ia1rS26D.AAAAcDo",
  CLICK_FINISHED: "RdurS26D.AAAAcB8",
  CLICK_RESET: "enfLS26D.AAAAb.7",
  CLICK_SEARCH: "MFhnS26D.AAAAQpk",
  ENTER_PARCEL_NUMBER: "XArzS26D.AAAAb5F",
};
